import React from 'react';

/**
 * 員工搜尋輸入框元件
 * @param {function} reloadDispatchCalendar - 用於重新載入派工日曆的回調函數，接受員工名稱作為參數
 * @returns {JSX.Element} 員工搜尋輸入框元件
 * @component
 */
export default function EmployeeSearch({
  reloadDispatchCalendar = (employeeName) => {},
}) {
  const [employeeName, setEmployeeName] = React.useState('');
  const isComposing = React.useRef(false);

  React.useEffect(() => {
    if (!isComposing.current) {
      reloadDispatchCalendar(employeeName);
    }
  }, [employeeName, isComposing]);

  return (
    <div className="w-25">
      <label htmlFor="employeeSearch">員工搜尋：</label>
      <input
        className="form-control"
        type="text"
        value={employeeName}
        onCompositionStart={() => (isComposing.current = true)}
        onCompositionEnd={() => {
          isComposing.current = false;
          reloadDispatchCalendar(employeeName);
        }}
        onChange={(e) => setEmployeeName(e.target.value)}
        id="employeeSearch"
      />
    </div>
  );
}
